/* eslint-disable jsx-a11y/alt-text */
import React, { Suspense } from "react";
export function Loader(props) {
  var loadingMessage =
    props.loadingMessage !== undefined && props.loadingMessage !== ""
      ? props.loadingMessage
      : "Loading please wait..";
  return (
    <>
      <div className="page-loading text-center">
        <div className="content">
          <img
            src="assets/img/app-assetz.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "}
          <h6 className="mb-0">{loadingMessage}</h6>
        </div>
      </div>
    </>
  );
}

export function LogoutLoader() {
  return (
    <>
      <div className="page-loading text-center">
        <div className="content">
          <img
            src="assets/img/app-assetz.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "}
          <h6 className="mb-0">Logging out...</h6>
        </div>
      </div>
    </>
  );
}

export function RedirectLoader() {
  return (
    <>
      <div className="page-loading text-center">
        <div className="content">
          <img
            src="assets/img/app-assetz.png"
            className="flipimg"
            width={"50px"}
          ></img>{" "}
          <h6 className="mb-0">Redirecting to Assetz...</h6>
        </div>
      </div>
    </>
  );
}

